export enum ReadingsMenuTab {
    MeterReadings = 0,
    AssignedReadings = 1,
}